import { map, pathOr, pipe, path } from 'ramda';

export const getPoVendor = (state, id) => pathOr(null, ['products', 'purchaseOrders', 'vendors', 'byId', id], state);

export const getPoVendorIds = pathOr([], ['products', 'purchaseOrders', 'vendors', 'list']);

export const getPoVendors = state => pipe(
  getPoVendorIds,
  map(id => getPoVendor(state, id)),
)(state);

export const isLoadingVendors = path(['products', 'purchaseOrders', 'vendors', 'loading']);
